export enum CategoriaVariavelControleEnum {
    ESTACAO = 'estacao',
    GRAO = 'grao',
    OPERACAO = 'operacao',
}
